/**
 * The Player class acts as the view object for the player.
 */
const tbs_model_vo_DemoTabOne = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_DemoTabOne.prototype = {
    /* The view object name */
    name: 'tabOneData',
    /* The view object instance */
    view: {
        get: {
            baseUrl: 'https://cpb.bingouai.com',
            apiPrefix: '/api/res',
            apiSuffix: 'accessKey=baseball-stats',
            service: '/rankings/player',
            query: {
            },
            basePath: 'data',
            rule: {
                label: 'name'
            }
        },
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
}

module.exports = tbs_model_vo_DemoTabOne